export const DEFAULT_CARD_CURRENCY = {
  value: 2,
  label: "AUD",
  symbol: "$",
};

export const selectCardCurrencyName = (state) =>
  state.user.cardCurrencyName || DEFAULT_CARD_CURRENCY;

export const normalizeCardCurrency = (currency) =>
  currency || DEFAULT_CARD_CURRENCY;
